// Registers the public/service-worker.js and forces instant activation on update.

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // When a new SW is found, skip waiting so it takes control immediately
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New update available; tell it to activate now
                registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
              }
            }
          });
        });

        // If there's a waiting SW already (e.g., from a previous visit), activate it
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Auto reload when controller changes (new SW in control)
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch(() => {
        // ignore
      });
  });
}

export {};


